import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2'; 
import { LoginService } from '../../Services/login.service';
import { safeSessionStorage } from '@shared/safe-web-storage';

const sessionStorage = safeSessionStorage;


@Component({
    selector: 'app-verificar',
    templateUrl: './verificar.component.html',
    styleUrls: ['./verificar.component.css'],
    standalone: false
})
export class VerificarComponent implements OnInit {
  public ParamVerifica:string ;
  constructor(private loginService:LoginService,protected rt:ActivatedRoute,public router: Router) { 
    this.ParamVerifica = this.rt.snapshot.paramMap.get('CrypMail') || '';
    this.Registro();
  }

  ngOnInit(): void {
  }

  async Registro() {
    let response:any;
    response = await this.loginService.Verficar({CrypMail:''+this.ParamVerifica+''});
    if (response[0].Correcto == 1 ){
        sessionStorage.setItem('IdUsuario', response[0].IdUsuario)
        sessionStorage.setItem('Nombre', response[0].Nombre)
        sessionStorage.setItem('Mail', response[0].Mail)
        Swal.fire('Hola', response[0].Mensaje  , 'success').then((result) => {
       if (result.value) {
          this.router.navigateByUrl('/');
        } });
    }
    else
    {
      Swal.fire('Upss', response[0].Mensaje, 'error')
    }  
    
 }

}
